var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean bibendum arcu id tellus posuere tempor. ")])])
}]

export { render, staticRenderFns }